// extracted by css-extract-rspack-plugin
export default {"AddAuthorizedSignerBanner":"sputnik__AddAuthorizedSignerBanner__CJzgF","addAuthorizedSignerBanner":"sputnik__AddAuthorizedSignerBanner__CJzgF"};